import React from 'react';
import ReactModal, { Props as ReactModalProps } from 'react-modal';

export interface RhModalProps extends ReactModalProps {
  children: React.ReactNode;
  contentStyle?: React.CSSProperties;
}

export const RhModal = ({ contentStyle = {}, ...rest }: RhModalProps) => {
  return (
    <ReactModal
      style={{
        ...styles.modal,
        content: {
          ...styles.modal.content,
          ...contentStyle,
        },
      }}
      ariaHideApp={false}
      {...rest}
    />
  );
};

const styles = {
  modal: {
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.68)',
    },
    content: {
      border: 'none',
      borderRadius: 12,
      background: '#fff',
      minWidth: '33%',
      top: '50%',
      left: '50%',
      bottom: 'unset',
      right: 'unset',
      transform: 'translate(-50%, -50%)',
      padding: 30,
    },
  },
};
